import { useEffect } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import { Logger, Section } from '@wolfdanepug/common-react'
import Marketing from './Marketing'

export default function PlanReview({ quote = {}, name = 'plan-details' }: any) {
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

	useEffect(() => {
		Logger.log('[quote] Plan', quote)
	}, [quote])

	return (
		<>
			<Section sx={styles.promote}>
				<Marketing isMobile={isMobile} />
			</Section>

			{/* <Section header={appData.reviews.header} sx={styles.reviewsSection}>
				<GridList items={appData.reviews.items} sx={styles.reviews} component={ReviewItem} />
			</Section> */}
		</>
	)
}

const styles = {
	hero: {
		root: {
			width: '100%',
			backgroundColor: '#fff',
			pt: 12,
			pb: '200px'
		}
	},
	reviewsSection: {
		root: {
			paddingTop: '200px',
			paddingBottom: 10
		},
		header: {
			mb: 6
		}
	},
	reviews: {
		item: {
			root: {
				height: '100%'
			}
		}
	},
	promote: {
		root: {
			width: '100%',
			position: 'relative',
			backgroundColor: '#fff2e1',
			// pt: 15,
			pb: 15,
			'&:before': {
				position: 'absolute',
				content: '""',
				width: 0,
				height: 0,
				top: -200,
				borderStyle: 'solid',
				borderColor: 'transparent transparent #fff2e1 transparent',
				borderWidth: '0 0 200px 100vw'
			},
			'&:after': {
				position: 'absolute',
				content: '""',
				width: 0,
				height: 0,
				bottom: -200,
				borderStyle: 'solid',
				borderColor: 'transparent transparent transparent #fff2e1',
				borderWidth: '0 0 200px 100vw',
				zIndex: 0
			}
		}
	}
}
